import React from "react";
import axios from "axios";
import CoursePriceCalculationModal, { calcTotalPricePayedType0 } from "../../components/Course/CoursePriceCalculationModal";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import StorageCreateInvoice from "../../components/Storage/StorageCreateInvoice";

function SwimmingSaleDetails() {
  // const dollarPrices = useSelector(state => state.dollarPrices.dollarPrices)
  const currentCenterId = '66bdca9b7add38fef2918d63'
  const [priceModal, setPriceModal] = useState({
    show: false,
    data: {},
    paymentDetails: {},
    payedType: 0,
    changeType: 1
  })
  const currentDollarPrice = useSelector(state => state.dollarPrices.currentPrice.price);
  const history = useHistory()
  const onSubmit = (selectedProducts) => {
    const data = {
      price: selectedProducts.reduce((a, b) => a + (b.price * b.quantity), 0),
      items: selectedProducts.map((a) => {
        return {
          ...a,
          itemId: a._id,
        }
      }),
      centerId: currentCenterId,
    }
    onChangeModal(data)
  }
  const onChangeModal = (pck = {}) => {

    const dt = { ...pck, iqd: pck.price }
    delete dt.price

    setPriceModal(prev => ({ ...prev, show: !prev.show, data: dt }))
  }


  const onSubmitt = async () => {
    const data = {
      ...priceModal.data,
      price: calcTotalPricePayedType0({ data: { iqd: priceModal.data.iqd } }, currentDollarPrice),
      iqd: priceModal.data.iqd,
      paymentDetails: {
        ...priceModal.paymentDetails, payedType: priceModal.payedType,
        changeType: priceModal.changeType
      },
    }
    try {
      await axios.post('/swimming-sales', data)
      setPriceModal(prev => ({ ...prev, show: false, data: {} }))
      history.goBack()
    } catch (e) {
      console.log(e)
      alert(e)
    }
  }
  const onChangeModalData = (data) => {
    setPriceModal(data)
  }
  return (
    <div className="flex w-full h-full bg-white ">
      <CoursePriceCalculationModal onSubmit={onSubmitt} onChangeModalData={onChangeModalData} priceModal={priceModal} onChangeModal={onChangeModal} />

      <div className='flex flex-col w-full h-full' >
        <StorageCreateInvoice storageQuery={'/swimming-storage/' + currentCenterId} currencyType='iqd' stockQuery={'/swimming-stocks'} onClickSubmit={onSubmit} />
      </div>
    </div>
  );
}

export default SwimmingSaleDetails;